// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as ValueElement from "./ValueElement.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var wrapper = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 768px)", {
            hd: BsCss.display("flex"),
            tl: {
              hd: BsCss.justifyContent("spaceBetween"),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: BsCss.media("(min-width: 1440px)", {
              hd: BsCss.width(BsCss.pct(55.0)),
              tl: /* [] */0
            }),
        tl: {
          hd: BsCss.media("(min-width: 768px) and (max-width: 1440px)", {
                hd: BsCss.width(BsCss.pct(50.0)),
                tl: /* [] */0
              }),
          tl: /* [] */0
        }
      }
    });

var leftContainer = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 768px)", {
            hd: BsCss.width(BsCss.pct(45.0)),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var rightContainer = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 768px)", {
            hd: BsCss.marginTop(BsCss.px(50)),
            tl: {
              hd: BsCss.width(BsCss.pct(45.0)),
              tl: /* [] */0
            }
          }),
      tl: /* [] */0
    });

var Styles = {
  wrapper: wrapper,
  leftContainer: leftContainer,
  rightContainer: rightContainer
};

function AllValues(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ValueElement.make, {
                              valueIconUrl: "/images/about/value/openness.svg",
                              brandText: "Give",
                              titleText: "openness",
                              bodyText: "We keep our minds and doors open to new possibilities."
                            }),
                        JsxRuntime.jsx(ValueElement.make, {
                              valueIconUrl: "/images/about/value/magic.svg",
                              brandText: "Give",
                              titleText: "magic",
                              bodyText: "We're always thinking of ways to keep our customers wowed."
                            })
                      ],
                      className: leftContainer
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ValueElement.make, {
                              valueIconUrl: "/images/about/value/greatness.svg",
                              brandText: "Give",
                              titleText: "greatness",
                              bodyText: "We make it even more awesome by striving for excellence, always!"
                            }),
                        JsxRuntime.jsx(ValueElement.make, {
                              valueIconUrl: "/images/about/value/damn.svg",
                              brandText: "Give",
                              titleText: "a damn",
                              bodyText: "We care enough to make this a great place to work."
                            })
                      ],
                      className: rightContainer
                    })
              ],
              className: wrapper
            });
}

var make = AllValues;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
